import { MDBCol, MDBRow } from "mdb-react-ui-kit";
import { FC } from "react";
import Image from "next/image";
import styles from "../../../styles/home/Home.module.scss";
import locationSvg from "../../../utils/svg-icon/location";

const HomeHeadDetailMobile: FC = () => {
    const { Italy } = locationSvg;
    return (
        <MDBRow
            center
            className={`pt-5 pl-2 pr-3 displayTabletSm ${styles.homeHeadDetail}`}
        >
            <MDBCol
                className={`${styles.headRowCardContainer} bg-white rounded-9 `}
            >
                <MDBRow className="pt-4 pb-3">
                    <MDBCol
                        size={12}
                        md={4}
                        className={`px-4 px-lg-5 ${styles.featureCard}`}
                    >
                        <MDBRow>
                            <MDBCol size={3} md={4}>
                                <div className={styles.headWorldIcon}>
                                    <Image
                                        src="/custom-icons/home-custom/italy-hand.svg"
                                        alt="italy-hand"
                                        width={33}
                                        height={37}
                                        style={{ objectFit: "contain" }}
                                    />
                                </div>
                            </MDBCol>

                            <MDBCol
                                size={9}
                                md={8}
                                className="d-flex align-items-center"
                            >
                                <MDBRow>
                                    <MDBCol size={12}>
                                        <h4>Italian Expertise</h4>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                    <MDBCol
                        size={12}
                        md={4}
                        className={`px-4 px-lg-5 ${styles.featureCard}`}
                    >
                        <MDBRow>
                            <MDBCol size={3} md={4}>
                                <div className={styles.headWorldIcon}>
                                    <Italy alt="italy" />
                                </div>
                            </MDBCol>

                            <MDBCol
                                size={9}
                                md={8}
                                className="d-flex align-items-center"
                            >
                                <MDBRow>
                                    <MDBCol size={12}>
                                        <h4>
                                            Discover Italy
                                            <br />
                                            in a Premium Way
                                        </h4>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>

                    <MDBCol
                        size={12}
                        md={4}
                        className={`px-4 px-lg-5 ${styles.featureCard}`}
                    >
                        <MDBRow>
                            <MDBCol size={3} md={4}>
                                <div className={styles.headWorldIcon}>
                                    <Image
                                        src="/custom-icons/home-custom/sun.svg"
                                        alt="sun"
                                        width={46}
                                        height={29}
                                        style={{ objectFit: "contain" }}
                                    />
                                </div>
                            </MDBCol>

                            <MDBCol
                                size={9}
                                md={8}
                                className="d-flex align-items-center"
                            >
                                <MDBRow>
                                    <MDBCol size={12}>
                                        <h4>Crafted for You</h4>
                                    </MDBCol>
                                </MDBRow>
                            </MDBCol>
                        </MDBRow>
                    </MDBCol>
                </MDBRow>
            </MDBCol>
        </MDBRow>
    );
};

export default HomeHeadDetailMobile;
